module.exports = __webpack_public_path__ + "img/icn.3f692eb0.svg";